/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {
  useCallback,
  useRef
} from 'react';
import {useDispatch} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';
import {CellMenu} from '@ion/dls/src/components/grid/CellMenu';
import {CellMenuItem} from '@ion/dls/src/components/grid/CellMenuItem';
import {ViewRecordIcon} from '@ion/dls/src/icons/ViewRecordIcon';
import {IconSize} from '@ion/dls/src/types/types';
import {viewAlertsNotification} from '../alertsNotifications/state';

// defines the alert row editor prop definitions ...
export interface AlertRowEditorTypes {
  alert: GenericObject;
}

const Icon = React.memo(() => (
  <ViewRecordIcon size={IconSize.medium} />
));

/**
 * Defines the AlertRowEditor component. This component contains
 * the cell actions for the alert grid.
 *
 * ```typescript
 *
 *   import {AlertRowEditor} from './AlertRowEditor';
 *
 *   <AlertRowEditor .../>
 *
 * ```
 */
export const AlertRowEditor = ({alert}: AlertRowEditorTypes) => {
  const dispatch    = useDispatch();
  const cellMenuRef = useRef(null);

  const closeMenu = useCallback(() => {
    cellMenuRef.current.closeCellMenu(cellMenuRef.current, true);
  }, []);

  const viewAlertDetails = useCallback(() => {
    dispatch(viewAlertsNotification(alert));
    closeMenu();
  }, [dispatch]);

  return (
    <>
      <CellMenu ref={cellMenuRef} menuItems={
        <div>
          <CellMenuItem icon={<Icon />}
            onClick={viewAlertDetails}
            label={translate('admin-devices:view.alertHistory.grid.view')} />
        </div>
      } />
    </>
  );
};
